import Testimonial3 from '@assets/testimonials/social/JD.jpg';
import Testimonial1 from '@assets/testimonials/social/Josh-Carter.jpg';
import Testimonial2 from '@assets/testimonials/social/Josh-Johnson.jpg';
import Testimonial5 from '@assets/testimonials/social/Photo 2020-02-11, 10 22 42 AM.jpg';
import Testimonial6 from '@assets/testimonials/social/Photo 2020-04-08, 6 03 53 PM.jpg';
import Testimonial7 from '@assets/testimonials/social/Photo 2020-04-10, 7 44 12 AM.jpg';
import Testimonial8 from '@assets/testimonials/social/Photo 2020-04-10, 7 44 30 AM.jpg';
import Testimonial4 from '@assets/testimonials/social/Photo 2020-04-10, 7 44 45 AM.jpg';
import Testimonial9 from '@assets/testimonials/social/Results-2.jpg';
import Testimonial10 from '@assets/testimonials/social/Screen Shot 2020-04-17 at 12.24.31 PM.png';
import Testimonial11 from '@assets/testimonials/social/Screen Shot 2020-04-21 at 10.16.21 AM.png';
import React from 'react';
import styled from 'styled-components';
import { Highlighter } from '../../../components/GlobalStyles';
import TestimonialGrid from '../../../components/TestimonialGrid/TestimonialGrid';
import { H2 } from '../../../components/Typography/Typography';
import { CurvedArrow, ThumbsUpBubble } from '../../../icons/Icons';

const testimonials = [
  { type: 'image', src: Testimonial1 },
  { type: 'image', src: Testimonial2 },
  { type: 'image', src: Testimonial3 },
  { type: 'image', src: Testimonial4 },
  { type: 'image', src: Testimonial5 },
  { type: 'image', src: Testimonial6 },
  { type: 'image', src: Testimonial7 },
  { type: 'image', src: Testimonial8 },
  { type: 'image', src: Testimonial9 },
  { type: 'image', src: Testimonial10 },
  { type: 'image', src: Testimonial11 },
];

export const SectionTestimonials = function() {
  return (
    <Container>
      <StyledThumbsUp />
      <Headline>
        The best <Highlighter highlightColor="var(--colorWhite)">part? This stuff gets results.</Highlighter>
      </Headline>
      <StyledArrow />
      <TestimonialGrid items={testimonials} />
    </Container>
  );
};

const Container = styled.section`
  margin: 0;
  padding: 10rem 4rem 3rem;
  position: relative;
  width: 100vw;

  background-color: var(--colorPrimaryLight);
`;

const StyledThumbsUp = styled(ThumbsUpBubble)`
  display: block;
  width: 8rem;
  margin-left: auto;
  margin-right: auto;
`;

const Headline = styled(H2)`
  z-index: 2;
  position: relative;

  text-align: center;
`;

const StyledArrow = styled(CurvedArrow)`
  display: none;
`;



// WEBPACK FOOTER //
// ./src/routes/Home/components/SectionTestimonials.js